import {connect} from 'react-redux';
import get from 'lodash/get';
import has from 'lodash/has';
import includes from 'lodash/includes';
import Header from './Header.jsx';
import * as ResourceApi from 'api/resources';
import {resourcesSelector} from 'resources/selectors';
import {logoutAction} from 'pages/Login/actions';
import {platformMappings, UserGroups, canRead} from 'utils/DBUtils';
import {getUserGroupName, getUserResourceActions} from 'pages/Profile/selectors';

// create selectors for getting resource- and service-permissions by resource type
const getSurveyAnswerActions = getUserResourceActions(ResourceApi.Types.SurveyUserAnswer);
const getFeaturedManagerActions = getUserResourceActions(ResourceApi.Types.FeaturedManager);
const getHomepageLayoutActions = getUserResourceActions(ResourceApi.Types.HomepageLayout);
const getRewardsActions = getUserResourceActions(ResourceApi.Types.RetailerItem);
const getRaffleActions = getUserResourceActions(ResourceApi.Types.Prize);
const getWinnerActions = getUserResourceActions(ResourceApi.Types.PrizeEntry);
const getUGCActions = getUserResourceActions(ResourceApi.Types.UGCSubmission);
const getUserActions = getUserResourceActions(ResourceApi.Types.User);
const getPublishLogActions = getUserResourceActions(ResourceApi.Types.PublishLogReport);

const mapStateToProps = (state, ownProps) => {
  const {editBreak, resources, user} = state;

  const {currentPlatform} = editBreak;
  const activePlatforms = Object.keys(platformMappings)
    .filter(key => has(editBreak.break, key))
    .map(key => platformMappings[key]);

  const masterBreakId = get(editBreak.break, 'MASTER', null);

  // the Beaker logo should only have a 'lang'-specific indicator next to it when the user
  // is actually viewing a break.
  const {router} = ownProps;
  const isViewingBreak = router.location.pathname.startsWith('/break');
  const lang = isViewingBreak ? get(resourcesSelector(resources), `${masterBreakId}.lang`, null) : null;

  // for hiding Tools menu items based on user group permissions
  const allowSurveyAnswers = canRead(getSurveyAnswerActions(state));
  const allowFeaturedManager = canRead(getFeaturedManagerActions(state));
  const allowHomepageManagement = canRead(getHomepageLayoutActions(state));
  const allowRewardsStore = canRead(getRewardsActions(state));
  const allowRafflePrizes = canRead(getRaffleActions(state));
  const allowWinners = canRead(getWinnerActions(state));
  const allowUGCModeration = canRead(getUGCActions(state));
  const allowUserManagement = canRead(getUserActions(state));
  const allowPublishLog = canRead(getPublishLogActions(state));

  // only root can visit this page
  const userGroupName = getUserGroupName(state);
  const allowMaintenance = userGroupName === UserGroups.Root;

  return {
    allowSurveyAnswers,
    allowFeaturedManager,
    allowHomepageManagement,
    allowRewardsStore,
    allowRafflePrizes,
    allowWinners: true,
    // allowWinners,
    allowUGCModeration,
    allowUserManagement,
    allowPublishLog,
    allowMaintenance,
    lang,
    router,
    challengeId: editBreak.selectedChallengeId,
    currentPlatform,
    activePlatforms,
    user
  };
};

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(logoutAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./public/components/Header/HeaderContainer.js